<script setup>
  import zhCN from 'ant-design-vue/es/locale/zh_CN'
  import { useThemeStore } from '@/store/modules/projectConfig'
  import { ACCESS_TOKEN } from '@/utils/constant'
  import {
    getWebLoginConfig,
    getTheme,
    getBrandLogo
  } from '@/apis/modules/corporateCulture'
  import store from 'store'
  import { onMounted } from 'vue'

  const themeStore = useThemeStore()
  // 获取登录前的主题色
  const getConfigData = () => {
    getWebLoginConfig().then((res) => {
      themeStore.fillColor({ primaryColor: res.themeColor || '#00b196' })
    })
  }
  // 获取登录后的主题色
  const getCurrentTheme = () => {
    getTheme().then((res) => {
      themeStore.fillColor({ primaryColor: res.themeColor })
    })
  }
  // 获取登录后的浏览器icon
  const getIcon = () => {
    getBrandLogo().then((res) => {
      themeStore.setIcon(res.brandLogoMini) // 设置浏览器icon
    })
  }
  onMounted(() => {
    // 设置主题色 未登录时
    if (!store.get(ACCESS_TOKEN)) {
      // getConfigData()
    } else {
      // 登录后
      // getCurrentTheme()
      // getIcon()
    }
  })
</script>

<template>
  <a-config-provider :locale="zhCN">
    <router-view></router-view>
  </a-config-provider>
</template>

<style lang="less">
  // 分页器样式
  .ant-pagination-total-text {
    line-height: 32px !important;
  }
  .ant-pagination-item-active:hover,
  .ant-pagination-item-active:hover a,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-pagination-options-quick-jumper input:hover,
  // tabs-card
  .ant-radio-button-wrapper-checked[data-v-7ed1624e]:not(
      .ant-radio-button-wrapper-disabled
    ):hover {
    border-color: @primary-color !important;
    color: @primary-color !important;
  }

  // tabs样式
  .ant-tabs-tab:hover,
  .ant-tabs-tab-btn:focus,
  .ant-tabs-tab-remove:focus,
  .ant-tabs-tab-btn:active,
  .ant-tabs-tab-remove:active {
    color: @primary-color !important;
  }

  // 输入框
  .ant-input:hover,
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
  .ant-input-number:hover,
  .ant-input-number-affix-wrapper:not(
      .ant-input-number-affix-wrapper-disabled
    ):hover {
    border-color: @primary-color !important;
  }
  // .ant-input-affix-wrapper:focus,
  // .ant-input-affix-wrapper-focused {
  //   box-shadow: none !important;
  // }
</style>
